/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { delayedResponse, makeMockResponse } from '../mockUtils';
import { ReportsListDto } from './reportsClient.typings';
import { reportsByDayDtoFactory, reportsDtoFactory } from './reportsFactories';

const REPORTS_URL = /reports\/cashBox$/;
const REPORTS_BY_DAY_URL = /reports\/cashBoxDay/;

export function addReportsMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onPost(REPORTS_URL).reply((config) => {
        const body = JSON.parse(config.data);

        const data: ReportsListDto = {
            afterKey: 'last_cashBox_taxNumber',
            reports: reportsDtoFactory.list({ count: body.limit }),
        };

        return delayedResponse(makeMockResponse(200, data, config), 500);
    });
}

export function addReportsByDayMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onPost(REPORTS_BY_DAY_URL).reply((config) => {
        const body = JSON.parse(config.data);

        const data: ReportsListDto = {
            afterKey: 'last_cashBox_taxNumber',
            reports: reportsByDayDtoFactory.list({ count: body.limit }),
        };

        return delayedResponse(makeMockResponse(200, data, config), 500);
    });
}
